import "./BuyBoxSocialProof.css";

type BuyBoxSocialProofProps = {
  buyerCount?: number;
  rating?: number;
};

const socialProofImageUrl =
  "https://cdn.shopify.com/s/files/1/0567/4365/7562/files/social-proof-image.webp?v=1781772366";

const isPositiveFiniteNumber = (value?: number): value is number =>
  typeof value === "number" && Number.isFinite(value) && value > 0;

const formatRating = (rating: number) => rating.toFixed(1).replace(".", ",");

export function BuyBoxSocialProof({
  buyerCount,
  rating,
}: BuyBoxSocialProofProps) {
  if (!isPositiveFiniteNumber(buyerCount) || !isPositiveFiniteNumber(rating)) {
    return null;
  }

  return (
    <div className="bundle-pdp__social-proof">
      <img
        alt=""
        className="bundle-pdp__social-proof-image"
        src={socialProofImageUrl}
      />
      <p className="bundle-pdp__social-proof-text">
        <strong>{buyerCount} Käufer</strong> in den letzten 30 Tagen ·{" "}
        {formatRating(rating)}★ Bewertung
      </p>
    </div>
  );
}
